import { ApiFactory } from "@api/ApiFactory";
import { withErrorHandler } from "@shared/utils/errorHandler";
import { RedirectHandler } from "@shared/utils/redirectHandler";

// FIXME: fetcherが複数あるので統合
export class FetcherUtil {
  private constructor() {}

  static async json<T>(
    url: string,
    throwOnError = true,
    appendOptions?: RequestInit,
    allowNotFound = false,
    notFoundDefaultValue: T | null = null,
  ): Promise<
    | { data: T; success: true }
    | { data: null; success: false; error: string; status: number }
  > {
    return withErrorHandler(async () => {
      const res = await fetch(url, {
        credentials: ApiFactory.credentialsInclude,
        cache: "no-cache",
        ...appendOptions,
        headers: {
          ...ApiFactory.commonHeader,
          ...appendOptions?.headers,
        },
      });

      if (res.ok) {
        return { data: await res.json(), success: true };
      }

      RedirectHandler.handleRedirect(res);

      if (res.status === 404 && allowNotFound) {
        return { data: notFoundDefaultValue, success: true };
      }

      // それ以外のステータスの場合もエラーとして扱う
      return FetcherUtil.handleError(res, throwOnError);
    }, `APIリクエストエラー: ${url}`);
  }

  private static handleError(
    res: Response,
    throwOnError: boolean,
  ): { data: null; success: false; error: string; status: number } {
    if (throwOnError) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    console.error(`HTTP error! status: ${res.status}`);

    return {
      data: null,
      success: false,
      error: res.statusText,
      status: res.status,
    };
  }
}
